/**
 * Standardized Inward Types
 * These are the actual values stored in the database
 */
export enum InwardType {
  SUPPLIER_INWARD = 'Supplier',
  STOCK_TRANSFER = 'Stock Transfer',
  LABOUR_INWARD = 'Labour',
  ORDER_RETURN = 'Order Return',
}

/**
 * Array of all valid inward types
 */
export const INWARD_TYPES = Object.values(InwardType);

/**
 * Map old inward type values to new standardized values (for backward compatibility)
 */
export const INWARD_TYPE_MAP: Record<string, InwardType> = {
  // Old values -> New values
  'direct': InwardType.SUPPLIER_INWARD,
  'Direct': InwardType.SUPPLIER_INWARD,
  'supplier_inward': InwardType.SUPPLIER_INWARD,
  'Supplier Inward': InwardType.SUPPLIER_INWARD,
  'Supplier': InwardType.SUPPLIER_INWARD,
  
  'stocktransfer': InwardType.STOCK_TRANSFER,
  'StockTransfer': InwardType.STOCK_TRANSFER,
  'stock_transfer': InwardType.STOCK_TRANSFER,
  'Stock Transfer': InwardType.STOCK_TRANSFER,
  
  'labourinward': InwardType.LABOUR_INWARD,
  'LabourInward': InwardType.LABOUR_INWARD,
  'labour_inward': InwardType.LABOUR_INWARD,
  'Labour Inward': InwardType.LABOUR_INWARD,
  'Labour': InwardType.LABOUR_INWARD,
  
  'salesorderreturn': InwardType.ORDER_RETURN,
  'SalesOrderReturn': InwardType.ORDER_RETURN,
  'sales_order_return': InwardType.ORDER_RETURN,
  'order_return': InwardType.ORDER_RETURN,
  'Order Return': InwardType.ORDER_RETURN,
  'Sales Order Return': InwardType.ORDER_RETURN,
};

/**
 * Normalize inward type to standardized value (for backward compatibility)
 * @param value - The inward type value to normalize
 * @returns The standardized inward type or default to SUPPLIER_INWARD
 */
export function normalizeInwardType(value: string | null | undefined): InwardType {
  if (!value) {
    return InwardType.SUPPLIER_INWARD; // Default
  }
  
  // If already a valid new value, return it
  if (INWARD_TYPES.includes(value as InwardType)) {
    return value as InwardType;
  }
  
  // Otherwise, try to map from old values
  const normalized = value.toLowerCase().trim();
  return INWARD_TYPE_MAP[normalized] || InwardType.SUPPLIER_INWARD;
}

